import { ApiApprovalCategory } from "@/types/approvals/approval-category.type.ts";
import { ApiApprovalCategoryType } from "@/types/approvals/approval-policy.types.ts";
import { RuleConditionType } from "@/types/role.types.ts";
import { SelectItem } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function useApprovalPolicyHook() {
  const { t } = useTranslation();

  const getCategoryInfo = (category: ApiApprovalCategory) => {
    switch (category.type) {
      case ApiApprovalCategoryType.time_off:
        return {
          title: t("approval:time_off_approvals"),
          caption: t("approval:setup_caption_time_off"),
        };
      case ApiApprovalCategoryType.hiring_plan:
        return {
          title: t("hiring_plan:position_request"),
          caption: t("approval:setup_caption_hiring_plan"),
        };
      case ApiApprovalCategoryType.offer:
        return {
          title: t("ats:job_offer_request"),
          caption: t("approval:setup_caption_job_offer"),
        };
      default:
        return { title: category.title, caption: category.description };
    }
  };

  const getFlowRuleTypes = (): SelectItem[] => {
    return [
      {
        id: RuleConditionType.employee,
        title: t("core:employee"),
        caption: t("core:rule_employee_approval_caption"),
      },
      {
        id: RuleConditionType.direct_manager,
        title: t("core:rule_direct_manager_title"),
        caption: t("core:rule_direct_manager_approval_caption"),
      },
      {
        id: RuleConditionType.manager_of_direct_manager,
        title: t("core:rule_manager_of_direct_manager_title"),
        caption: t("core:rule_manager_of_direct_manager_approval_caption"),
      },
      {
        id: RuleConditionType.department_manager,
        title: t("core:rule_department_manager_title"),
        caption: t("core:rule_department_manager_approval_caption"),
      },
      {
        id: RuleConditionType.custom_field_employee_reference,
        title: t("core:rule_custom_field_employee_reference"),
        caption: t("core:rule_custom_field_employee_reference_approval_caption"),
      },
    ];
  };

  const getFlowRuleTitleByType = (
    type: RuleConditionType,
    condition_entities?: SelectItem[] | undefined
  ): string => {
    const ruleType = getFlowRuleTypes().find((rule) => rule.id === type);
    let title = ruleType?.title ?? "";

    if (
      type == RuleConditionType.employee ||
      type == RuleConditionType.custom_field_employee_reference
    ) {
      title += ": " + condition_entities?.map((entity) => entity.title).join(", ");
    }

    return title;
  };

  return { getCategoryInfo, getFlowRuleTypes, getFlowRuleTitleByType };
}
